import { render, staticRenderFns } from "./TemplateSetting.vue?vue&type=template&id=0f228690"
import script from "./TemplateSetting.vue?vue&type=script&lang=js"
export * from "./TemplateSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports